import { Component,Input } from '@angular/core';
import {  NavController, NavParams } from 'ionic-angular';
import { ViewController } from 'ionic-angular';
import { AlertController } from 'ionic-angular';
import { LoadingController } from 'ionic-angular';
import { ImagePicker, ImagePickerOptions } from  '@ionic-native/image-picker';

import { Camera, CameraOptions } from '@ionic-native/camera';
import { Http, Headers, RequestOptions} from '@angular/http';

import { ApiUserProvider } from '../../providers/api-user/api-user';
//import{ Moment} from 'moment';
/**
 * Generated class for the EditModalPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-edit-modal',
  templateUrl: 'edit-modal.html',
})
export class EditModalPage {
  @Input() item: any; 
  @Input() DateT: string = new Date().toISOString();
  @Input() imageLists: any[] = [];
  @Input() RNote: string=""; 
  @Input() SelectedType: string=""; 
  @Input() SelectedHospital: string=""; 
  TypeList : Array<any>=[];
  HospitalList : Array<any>=[];
  public imageUploadLists:any[]=[];  
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public viewCtrl:ViewController, public apiUserProvider:ApiUserProvider,
    private http:Http,public alertCtrl: AlertController
    ,public loadingCtrl: LoadingController,
    public imagePicker: ImagePicker,//public moment:Moment,
   private camera: Camera) {
  }
 
  ionViewDidLoad() {
     this.item=this.navParams.get('MyItem');;
     this.DateT=this.item['RTime'];//"18:45";//this.navParams.get('DateT');//new Date('1968-11-16T03:20:00' );//this.item['RDate'].su);//this.moment..format("DD/MM/YYYY");//this.navParams.get('DateT');
     this.RNote=this.item['RNote'];
     
     this.imageLists.push("https://clinicapi.soft-planning.com/Images/"+ this.item['RFileName']+".jpg" );
     //this.navParams.get('imageLists');
     this.TypeList=this.navParams.get('TypeList');
     this.HospitalList=this.navParams.get('HospitalList');
     this.TypeList.forEach(e=>{
    if(e['TName']===this.item['RType'])
    {
      this.SelectedType=e['TSerial'];
    }
     });
     this.HospitalList.forEach(e=>{
      if(e['HName']===this.item['RHospital'])
      {
        this.SelectedHospital=e['HSerial'];
      }
       });
    console.log('ionViewDidLoad EditModalPage');
  }
  public closeModal(){
    var item = undefined;
    this.viewCtrl.dismiss(item);
  }
  public CheckRequired():boolean
  {
    if(this.DateT==="" || this.SelectedHospital==="" || this.SelectedType==="")
    {
        return false
    }
        return true;
  }
  public DoneModal()
  {
    if(!this.CheckRequired())
    {
      const alert2 = this.alertCtrl.create({
        title: 'رسالة خطأ',
        subTitle: 'اكمل البيانات',
        buttons: ['OK']
      });
      alert2.present();
    }
    else
    {
      this.EditMyData();
      //this.MyMenuProvider.RestaurantEval=this.rate;
      //this.MyMenuProvider.RestaurantNote=this.note;
      //var item = { 'rate' : this.rate ,'note' : this.note };
    
    }
  }
 EditMyData()
{
   let loader = this.loadingCtrl.create({
      content: "Please wait...",
      //duration: 3000,
    });
    loader.present();
  //let Df=this.datepipe.transform(this.DateFrom, 'yyyy-MM-dd');
    //var displaytime = this.DateT.toLocaleTimeString();
    let TH=this.DateT.toString().substr(0, this.DateT.toString().indexOf(':')); //.getHours();
    let TM=this.DateT.toString().substr( this.DateT.toString().indexOf(':')+1);

    var headers = new Headers();
    
    headers.append("Accept", 'application/json');
    headers.append('Content-Type', 'application/json' );
   
    const requestOptions = new RequestOptions({ headers: headers }); 
    let img=this.imageUploadLists[0];
      let postParams = {
        file:img,
       // ClinicID: this.apiUserProvider.ClinicID,
       // DocSerial:this.DocSerial,
       // USerial: this.apiUserProvider.USerial,
        //Df:Df,
        RSerial:this.item['RSerial'],
        TH:TH,
        TM:TM,
        HospitalSerial:this.SelectedHospital,
        TypeSerial:this.SelectedType,
        ResNote:this.RNote
      }
      
      this.http.post( this.apiUserProvider.MyDomain+'/api/Default/EditMyData',JSON.stringify(postParams), requestOptions)
      .map(res => res.json()).subscribe(data => {
        console.log("received data =>" + JSON.stringify(data));
      

         loader.dismiss();
         this.viewCtrl.dismiss(data);
        },err => {
          alert(this.imageLists[0]);
          alert(this.imageUploadLists[0]);
          console.log(err);
          loader.dismiss();
          const alert2 = this.alertCtrl.create({
            title: 'Error message',
            subTitle: err,
            buttons: ['OK']
          });
          alert2.present();
          });

    
}

  chooseFile3() {
    let options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      sourceType: this.camera.PictureSourceType.CAMERA,
      allowEdit: true,
      encodingType: this.camera.EncodingType.JPEG,
      targetWidth: 500,
      targetHeight: 500,
      saveToPhotoAlbum: false,      
    };  
    this.imageLists=[];
    this.imageUploadLists=[];
    this.camera.getPicture(options).then((img) => {

       this.imageLists.push('data:image/jpeg;base64,' +  img);
       this.imageUploadLists.push(  img);
    }).catch((reason) => {
      console.log(reason);
    });
  }


  ViewT(Serialvalue: string,Namevalue: string): void {
    this.SelectedType = Serialvalue;
   // this.TypeName = Namevalue;
  }
  ViewH(Serialvalue: string,Namevalue: string): void {
    this.SelectedHospital = Serialvalue;
    //this.HospitalName = Namevalue;
  }
  public loadMultipleImageFromGallery() {  
    let options = {  
        //here Quality of images, defaults to 100  
        quality: 100,  
        //here Width of an Image  
        width: 600,  
        //here Height of an Image  
        height: 600,  
        /** Output type, defaults to 0 (FILE_URI). 
 
        * FILE_URI :0 (number) it returns a actual path for an image 
 
        */  
        DATA_URI: 1,
        //(number) it returns a this.base64 data  for an image  
        outputType: 1  ,
        //here Maximum image count for selection, defaults to 15.  
        maximumImagesCount: 1//(1 - 15) numbers  
        //while setting a number 15 we can load 15 images in one selection.  
    };  
    this.imageLists=[];
    this.imageUploadLists=[];
    this.imagePicker.getPictures(options).then((results) => {  
        for (let index = 0; index < results.length; index++) {  
            //here iam converting image data to base64 data and push a data to array value.  
            this.imageLists.push('data:image/jpeg;base64,' + results[index]); 
            this.imageUploadLists.push( results[index]); 
           
        }  
        console.log('Image Lists', this.imageLists);  
    }, (error) => {  
        // Handle error   
        console.log('Error occurredwhile loading', error);  
    });  
} 
}



// WEBPACK FOOTER //
// ./src/pages/edit-modal/edit-modal.ts